import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { PageHeader } from "./fordon";
import { HubEditorial, faqSchema } from "@/components/HubEditorial";
import { FiNav, FiSwedishLink, hreflangPair } from "@/components/FiNav";
import { fiRapidoFaq, fiRapidoSections } from "@/data/fi-content";

const TITLE = "Rapido asuntoautot Suomeen – jälleenmyyjä Kalixissa";
const DESC =
  "Rapido-asuntoautot ja varaosat Kalixista, 90 km Torniosta. Puuton sandwich-runko, hyvä jälleenmyyntiarvo. Palvelemme suomeksi.";
const URL = "https://www.akhusbilfritid.se/fi/rapido";

export const Route = createFileRoute("/fi/rapido")({
  // FAQ-schemat byggs i loadern så guidens textdata hamnar i sidans egen
  // chunk i stället för i initial-bundlen.
  codeSplitGroupings: [["loader", "component"]],
  loader: () => ({ faqLd: faqSchema(fiRapidoFaq) }),
  head: ({ loaderData }) => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "fi_FI" },
      { property: "og:image", content: "https://www.akhusbilfritid.se/og-image.jpg" },
      { property: "og:image:alt", content: "Rapido asuntoauto" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://www.akhusbilfritid.se/og-image.jpg" },
    ],
    links: [{ rel: "canonical", href: URL }, ...hreflangPair("/fi/rapido", "/rapido")],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(faqSchema(fiRapidoFaq)) }],
  }),
  component: FiRapidoPage,
});

function FiRapidoPage() {
  return (
    <>
      <PageHeader
        label="Rapido · Erikoisosaamisemme"
        title={
          <>
            Rapido — runko, joka <span className="font-italic-display text-accent">kestää</span>.
          </>
        }
        sub="Ranskalainen Rapido rakentaa puuttomalla sandwich-rakenteella, joka ei lahoa kosteudesta samalla tavalla kuin puurunkoinen auto. Meiltä myös varaosat ja mallikohtainen neuvonta — suomeksi."
      />

      <FiNav />

      <section className="container-edge py-10">
        <div className="flex flex-wrap gap-3">
          <Link
            to="/fi/asuntoautot"
            className="inline-flex items-center gap-2 btn-shine rounded-full bg-primary px-5 py-3 text-sm font-semibold text-primary-foreground transition hover:bg-primary/90"
          >
            Katso varasto <ArrowRight size={14} />
          </Link>
          <Link
            to="/fi/yhteystiedot"
            className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-5 py-3 text-sm font-semibold transition hover:bg-secondary"
          >
            Kysy Rapidosta <ArrowRight size={14} />
          </Link>
        </div>
      </section>

      <HubEditorial
        eyebrow="Rapido-opas"
        sections={fiRapidoSections}
        faq={fiRapidoFaq}
        faqTitle="Usein kysytyt kysymykset"
      />

      <FiSwedishLink to="/rapido" label="Rapido på svenska" />
    </>
  );
}
